import { render, staticRenderFns } from "./RevealV2GeneKgPanel.vue?vue&type=template&id=6bd63618&scoped=true"
import script from "./RevealV2GeneKgPanel.vue?vue&type=script&lang=js"
export * from "./RevealV2GeneKgPanel.vue?vue&type=script&lang=js"
import style0 from "./RevealV2GeneKgPanel.vue?vue&type=style&index=0&id=6bd63618&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd63618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd63618')) {
      api.createRecord('6bd63618', component.options)
    } else {
      api.reload('6bd63618', component.options)
    }
    module.hot.accept("./RevealV2GeneKgPanel.vue?vue&type=template&id=6bd63618&scoped=true", function () {
      api.rerender('6bd63618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeRevealV2/RevealV2GeneKgPanel.vue"
export default component.exports